import styles from './Input.module.css';

interface InputProps {
	label: string;
	name: string;
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	error?: string;
	required?: boolean;
	mono?: boolean;
	type?: 'text' | 'number' | 'url' | 'password';
	disabled?: boolean;
	id?: string;
}

export function Input({
	label,
	name,
	value,
	onChange,
	placeholder,
	error,
	required = false,
	mono = false,
	type = 'text',
	disabled = false,
	id,
}: InputProps) {
	const inputId = id ?? name;

	return (
		<div className={styles.field}>
			<label htmlFor={inputId} className={styles.label}>
				{label}
				{required && <span className={styles.required}>*</span>}
			</label>
			<input
				id={inputId}
				name={name}
				type={type}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				disabled={disabled}
				required={required}
				className={[styles.input, mono ? styles.mono : '', error ? styles.inputError : '']
					.filter(Boolean)
					.join(' ')}
			/>
			{error && <span className={styles.errorText}>{error}</span>}
		</div>
	);
}
